(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-simple-text"] && !window.DesignMode) return;
  try {
    
  class RichTextTruncatable {
    constructor(container) {
      this.container = container;
      this.richTextContent = this.container.querySelector('.rich-text-content');
      this.expandButton = this.container.querySelector('[data-expand-toggle]');
      this.isExpanded = false;
      this.readMoreText = this.expandButton ? this.expandButton.textContent : 'Read more';
      this.readLessText = this.container.getAttribute('data-read-less-text');

      this.init();
    }

    init() {
      if (!this.expandButton) return;

      this.expandButton.addEventListener('click', this.toggleExpand.bind(this));
    }

    toggleExpand() {
      this.isExpanded = !this.isExpanded;

      if (this.isExpanded) {
        this.richTextContent.classList.add('expanded');
        this.expandButton.textContent = this.readLessText;
      } else {
        this.richTextContent.classList.remove('expanded');
        this.expandButton.textContent = this.readMoreText;

        // Scroll back to the top of the content
        this.richTextContent.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  // Initialize all rich text truncatable sections
  document.addEventListener('DOMContentLoaded', () => {
    const truncatableSections = document.querySelectorAll('[data-section-type="rich-text-truncatable"]');
    truncatableSections.forEach((section) => {
      new RichTextTruncatable(section);
    });
  });

  // Re-initialize when Shopify section events occur
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.dataset.sectionType === 'rich-text-truncatable') {
      new RichTextTruncatable(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
